var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-form',{attrs:{"elements":_vm.formElements},model:{value:(_vm.keywi),callback:function ($$v) {_vm.keywi=$$v},expression:"keywi"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }